import { useSelector } from 'react-redux';

import { WiwState } from 'store';

import { getLdClient } from 'ld-redux';

export function getLDFlag<T = boolean>(state: WiwState, flag: string): T {
  getLdClient()?.variation(flag);
  return (state.LD?.isLDReady && state.LD[flag]) || false;
}

export function useLDFlag<T = boolean>(flag: string): T {
  return useSelector((state: WiwState) => getLDFlag(state, flag));
}
